import { Typography } from '@mui/material';
import { Maybe } from 'graphql/jsutils/Maybe';
import { Resource as ResourceType } from '@/generated/contentfulTypes';

import Resource from '@/common/components/Resource/Resource';
import Brushbox from '@/common/components/Brushbox/Brushbox';
import {
  BrushboxColors,
  BrushboxVariants,
} from '@/common/components/Brushbox/Brushbox.interfaces';

import {
  styledHighlightedBenefitTitle,
  styledHighlightedBenefitWrapper,
} from './HighlightedBenefits.styled';

const HighlightedBenefitItem = ({ item }: { item: Maybe<ResourceType> }) => {
  return (
    <Brushbox
      sx={styledHighlightedBenefitWrapper}
      variant={BrushboxVariants.Rectangle}
      color={BrushboxColors.Red}
    >
      <Typography variant="body5" sx={styledHighlightedBenefitTitle}>
        {item && <Resource {...item} />}
      </Typography>
    </Brushbox>
  );
};

export default function HighlightedBenefits({
  highlightedBenefits,
}: {
  highlightedBenefits?: Maybe<ResourceType> | Maybe<ResourceType>[];
}) {
  if (!highlightedBenefits) return null;

  const benefits = Array.isArray(highlightedBenefits)
    ? highlightedBenefits
    : [highlightedBenefits];

  return benefits.length > 0
    ? benefits.map((item, index) => (
        <HighlightedBenefitItem key={index} item={item} />
      ))
    : null;
}
